import type { TableQuery, MailFolderTableQuery } from 'owa-mail-list-store';
import {
    isCopilotResultsTable,
    isSearchFolderScenario,
    type TableQueryType,
} from 'owa-mail-list-store';

export default function shouldShowFolderTag(tableQuery: TableQuery): boolean {
    // Show folder tags if user is in a persona or category favorite folder or a search folder
    if (tableQuery.type === 0) {
        const { scenarioType } = tableQuery as MailFolderTableQuery;
        return isSearchFolderScenario(scenarioType);
    } else if (isCopilotResultsTable(tableQuery)) {
        // Show folder tags in CopilotResults view since it can show results from multiple folders
        return true;
    }

    // .... or in search results
    return tableQuery.type === 1;
}
